<div class="main">
    <div class="bg">
        <h1>Earthling artifact Room. <br> You have reached a room full of toys. </h1><div style="margin-top: 20vh; position: absolute;"><b>Personality disorders: </b>
            People with personality disorders have extreme and inflexible personality traits that are distressing to the person and/or cause problems in work, school, or social relationships.
            Examples include antisocial personality disorder, obsessive-compulsive personality disorder, histrionic personality disorder, schizoid personality disorder, and paranoid personality disorder.</div>
        
        <img src="../../assets/images/torchesbg.png">
    </div>
    <div class="toys">
    <div class = "paper" (click) = "popup = true"></div>
    <img *ngIf = "popup" (click) = "popup = false" class = "paper p1" src="../../assets/images/Questionpapertoys.png">
    <img class = "i0"src="../../assets/images/toy1.png" cdkDrag>
    <img class = "i1"src="../../assets/images/toy2.png" cdkDrag>
    <img class = "i2"src="../../assets/images/toy3.png" cdkDrag>
    <img class = "i3"src="../../assets/images/toy4.png" cdkDrag>
    <img class = "i4"src="../../assets/images/toy5.png" cdkDrag>
    <img class = "i5"src="../../assets/images/toy6.png" cdkDrag>
    <img class = "i6"src="../../assets/images/toy7.png" cdkDrag>
    <img class = "i7"src="../../assets/images/toy8.png" cdkDrag>
    <img class = "i8"src="../../assets/images/toy9.png" cdkDrag>
    <img class = "i9"src="../../assets/images/toy10.png" cdkDrag>
    <img class = "i10"src="../../assets/images/toy11.png" cdkDrag>
    <img class = "i11"src="../../assets/images/toy12.png" cdkDrag>
    </div>
</div>